// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3Tq_8","Label":"Checkbox_Label__oPv2Q","InputElement":"Checkbox_InputElement__3m8wA","Invalid":"Checkbox_Invalid__2qAH1"};